import { Badge, Text } from '@mantine/core';

interface Props {
	label: string;
}

/** Small outlined tag for allocation metadata (transaction type, investment kind). */
export const MetaBadge = ({ label }: Props) => (
	<Badge
		variant="outline"
		size="sm"
		mih="1.25rem"
		h="1.25rem"
		radius="0.25rem"
		p="0 0.25rem"
		color="gray.4"
	>
		<Text fz="sm" fw={400} lh={1} c="dark.0">
			{label}
		</Text>
	</Badge>
);
